import { PassouFalhouEnum } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/enums-consultaSeguimento'
import { calculateResultadoPergunta19 } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-19/utils-consultaSeguimentoPergunta19'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'
import { isUndefinedOrNull } from 'util/checks'

import { HistoricoMChatHeaderTableItem } from '../components/HistoricoMchatHeaderTableItem'
import { HistoricoMChatPerguntaSection } from '../components/HistoricoMchatPerguntaSection'
import { HistoricoMChatResultadoParcialTableItem } from '../components/HistoricoMChatResultadoParcialTableItem'
import { HistoricoMChatSimpleVerticalTableItem } from '../components/HistoricoMChatSimpleVerticalTableItem'
import { getOutroOuPergunta, getOutroOuResposta } from '../utils-HistoricoMchatRf'
import { convertAplicacaoPergunta19 } from './converter-HistoricoMchatPergunta19'

interface HistoricoMChatRfPergunta19Props {
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
}

export const HistoricoMChatRfPergunta19 = (props: Readonly<HistoricoMChatRfPergunta19Props>) => {
  const { aplicacoes } = props

  const converted = convertAplicacaoPergunta19(aplicacoes)
  if (converted === null) return null

  const { header, situacoes, model } = converted
  if (isUndefinedOrNull(header)) return null

  const resultado = calculateResultadoPergunta19(model)

  return (
    <HistoricoMChatPerguntaSection>
      <HistoricoMChatHeaderTableItem
        numeroPergunta='19'
        title={header.textoPergunta}
        value={header.stPassou}
        pergunta={undefined}
      />

      {situacoes.map((situacao) => (
        <HistoricoMChatSimpleVerticalTableItem
          key={situacao.pergunta}
          pergunta={`"${getOutroOuPergunta(situacao)}"`}
          resposta={getOutroOuResposta(situacao)}
        />
      ))}

      {resultado && <HistoricoMChatResultadoParcialTableItem valor={resultado === PassouFalhouEnum.PASSOU} />}
    </HistoricoMChatPerguntaSection>
  )
}
